<template>
    <v-container>
        <h1 class="titulo mb-3">Sincronização Manual</h1>
        <v-card class="v-card card-container">
            <v-card-text>
                <div>
                    <div id="tabs" class="container">
                        <div class="tabs">
                            <div><a @click="activetab=ALL_SYNCS" :class="{ active: activetab === ALL_SYNCS }">Sinc. Manual</a></div>
                            <div><a @click="activetab=PROPOSAL_SYNCS" :class="{ active: activetab === PROPOSAL_SYNCS }">Sinc. Propostas</a></div>
                        </div>
                        <div class="content">
                            <div v-show="activetab === ALL_SYNCS" class="tabcontent">
                                <TodasSincronizacoesManuais ref="allSyncs" />
                            </div>
                            <div v-show="activetab === PROPOSAL_SYNCS" class="tabcontent">
                                <SincronizacaoPropostas />
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import TodasSincronizacoesManuais from '../../fragments/SincronizacaoManual/TodasSincronizacoesManuais.vue'
  import SincronizacaoPropostas from '../../fragments/SincronizacaoManual/SincronizacaoPropostas.vue'

  export default {
    name: 'SincronizacaoManual',
    components: { TodasSincronizacoesManuais, SincronizacaoPropostas },
    data: () => ({
      activetab: 'todas_as_syncs'
    }),
    computed: {
      ALL_SYNCS: () => 'todas_as_syncs',
      PROPOSAL_SYNCS: () => 'sync_propostas'
    }
  }
</script>

<style scoped lang="scss">
.title-date {
    color: var(--primary);
    font-weight: 800;
}
.listagem th {
    min-width: 90px;
}
.listagem th:nth-of-type(2) {
    min-width: auto;
}

@import url('../../assets/css/tabs.css');
</style>
